import type { NlsKey } from '../nls/strings_nls'
import type { ModuleKey } from './workspaceModules'
import type { ControlSection } from '../components/Member/memberControlsModel'
import type { MemberBoardSubTab } from '../components/Member/MemberBoardHub'
import type { MemberCollaborationSubTab } from '../member/memberAppRouting'
import type { HelperTabKey } from '../services/helper/helperStore'

export const MODULE_TITLE_NLS_KEYS: Record<ModuleKey, NlsKey> = {
  analysis: 'NLSWorkspaceModuleAnalysisTitle',
  automate: 'NLSWorkspaceModuleAutomateTitle',
  budget: 'NLSWorkspaceModuleBudgetTitle',
  design: 'NLSWorkspaceModuleDesignTitle',
  forms: 'NLSWorkspaceModuleFormsTitle',
  linkHub: 'NLSWorkspaceModuleLinkHubTitle',
  meetings: 'NLSWorkspaceModuleMeetingsTitle',
  quota: 'NLSWorkspaceModuleQuotaTitle',
  reports: 'NLSWorkspaceModuleReportsTitle',
  stock: 'NLSWorkspaceModuleStockTitle',
  upload: 'NLSWorkspaceModuleUploadTitle',
  funPack: 'NLSWorkspaceModuleFunPackTitle',
  teaching: 'NLSWorkspaceModuleTeachingTitle',
  training: 'NLSWorkspaceModuleTrainingTitle',
  clientOutreach: 'NLSWorkspaceModuleClientOutreachTitle',
  construction: 'NLSWorkspaceModuleConstructionTitle',
  hospital: 'NLSWorkspaceModuleHospitalTitle',
  sites: 'NLSWorkspaceModuleSitesTitle',
  timesheets: 'NLSWorkspaceModuleTimesheetsTitle',
  delivery: 'NLSWorkspaceModuleDeliveryTitle',
  shops: 'NLSWorkspaceModuleShopsTitle',
  stays: 'NLSWorkspaceModuleStaysTitle',
  jobs: 'NLSWorkspaceModuleJobsTitle',
  clinics: 'NLSWorkspaceModuleClinicsTitle',
  plant: 'NLSWorkspaceModulePlantTitle',
}

export type ModuleHiddenSurfaces = {
  memberControls: ReadonlySet<ControlSection>
  memberBoard: ReadonlySet<MemberBoardSubTab>
  memberNexus: ReadonlySet<MemberCollaborationSubTab>
  helperTabs: ReadonlySet<HelperTabKey>
}

// R27 TB5 feeds the tab engine from this function (bottom-tab-bar.md TB-D9).
export function hiddenSurfacesForModules(switchedOff: ReadonlySet<ModuleKey>): ModuleHiddenSurfaces {
  const memberControls = new Set<ControlSection>()
  const memberBoard = new Set<MemberBoardSubTab>()
  const memberNexus = new Set<MemberCollaborationSubTab>()
  const helperTabs = new Set<HelperTabKey>()

  if (switchedOff.has('forms')) {
    memberControls.add('FORMS')
  }
  if (switchedOff.has('automate')) {
    memberControls.add('AUTOMATIONS')
  }
  if (switchedOff.has('analysis')) {
    memberBoard.add('ANALYSIS')
  }
  if (switchedOff.has('meetings')) {
    memberBoard.add('MEETINGS')
    memberNexus.add('HUDDLE')
    memberNexus.add('MEETINGS')
    helperTabs.add('MEETINGS')
  }

  return {
    memberControls,
    memberBoard,
    memberNexus,
    helperTabs,
  }
}
